<template>
  <div class="px-3">
    <ServiceWorker class="service-worker" :status="service_status" :name="service_name" :error="$v" hint="platform.card.formats.zero_click_service_name" v-model="service_name" @setStatus="setStatus" />
  </div>
</template>

<script>
import ServiceWorker from "@/components/PlatformSettings/ServiceWorker.vue";
import siteSettingsService from "@/api/siteSettingsService";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import formatSection, { saveResult } from "@/components/PlatformCard/formatSection";

export default {
  name: "ZeroClick",
  components: {
    ServiceWorker,
  },
  mixins: [validationMixin, formatSection],
  validations: {
    service_name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(120),
    },
  },
  data: () => ({
    service_name: "",
    service_status: 0,
  }),
  computed: {
    sectionKey() {
      return "ZeroClick";
    },
    formState() {
      return { worker_name: this.service_name };
    },
  },
  methods: {
    setStatus(val) {
      this.service_status = val;
    },
    load() {
      return siteSettingsService.getZeroClickPush(this.$route.params.id).then((resp) => {
        if (resp && resp.status === 200 && resp.data?.worker_name) {
          this.service_name = resp.data.worker_name;
        }
      });
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    save() {
      return siteSettingsService.setZeroClickPush(this.$route.params.id, this.formState).then((res) => saveResult(res, this.$t("save_failed")));
    },
  },
};
</script>

<style scoped lang="scss">
.service-worker {
  max-width: 700px;
}
</style>
